import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { LogOut, Home, ChevronLeft, Bell } from "lucide-react";
import { useState, useEffect } from "react";
import api from "@/utils/api";

const Header = ({ title, showBack = false, backPath = "/home" }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user) return;
    const fetchCount = () => {
      api.get("/notifications/count")
        .then((r) => setUnreadCount(r.data.unread_count || 0))
        .catch(() => {});
    };
    fetchCount();
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, [user]);

  return (
    <header className="sticky top-0 z-50 bg-[#1A3560] text-white shadow-lg">
      <div className="flex items-center justify-between px-4 h-14">
        <div className="flex items-center gap-2">
          {showBack && (
            <button
              data-testid="header-back-btn"
              onClick={() => navigate(backPath)}
              className="p-2 rounded-lg hover:bg-white/10 active:scale-95 transition-all"
              title="Back"
            >
              <ChevronLeft size={22} />
            </button>
          )}
          <button
            data-testid="header-home-btn"
            onClick={() => navigate("/home")}
            className="p-2 rounded-lg hover:bg-white/10 active:scale-95 transition-all"
            title="Home"
          >
            <Home size={20} />
          </button>
          <div>
            <span className="font-extrabold text-lg tracking-tight">AMPL</span>
            {title && (
              <span className="ml-2 text-white/70 text-sm font-medium">{title}</span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {user && (
            <div className="hidden sm:block text-right mr-1">
              <p className="text-xs text-white/70 leading-none">{user.role}</p>
              <p className="text-sm font-semibold leading-tight">{user.full_name}</p>
            </div>
          )}
          {/* Bell icon */}
          <button
            data-testid="header-bell-btn"
            onClick={() => navigate("/notifications")}
            className="relative p-2 rounded-lg hover:bg-white/10 active:scale-95 transition-all"
            title="Notifications"
          >
            <Bell size={20} />
            {unreadCount > 0 && (
              <span
                data-testid="notification-badge"
                className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] bg-[#DC2626] text-white text-[10px] font-extrabold rounded-full flex items-center justify-center px-1"
              >
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </button>
          <button
            data-testid="header-logout-btn"
            onClick={logout}
            className="p-2 rounded-lg hover:bg-white/10 active:scale-95 transition-all"
            title="Logout"
          >
            <LogOut size={20} />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
